import { render, staticRenderFns } from "./StavL.vue?vue&type=template&id=d46761aa"
import script from "./StavL.vue?vue&type=script&lang=js"
export * from "./StavL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports